
export const siteentrylist = {
    SuccessMessages: {
        TRAINING_SOKUSHIN_MSG: "初回入場のため教育実習を実施してください。教育用 NFC タグにスマホをタッチしてください。",
        PHONE_VALID: "11桁の電話番号を入力してください。",
    },
    ErrorMessages: {
        REGISTRATION_ERR: "登録に失敗しました。しばらく経ってから再度お試しください。",
        FAILED_LOGIN: "電話番号で入退場し管理者に通知"
    },
    Labels: {
        NEW_ENTRY_SCREEN: "新規入場画面",
        NEW_ENTRY: "新規入場",
        ENTRY_DATE_LBL: "入場日",
        ROLE_LBL: "あなたの役割",
        HEALTH_CONDITION_LBL: "今日の体調",
        INJURY_NOTE_LBL: "怪我などの状況",
        BLOOD_PRESSURE_LBL: "今日の血圧",
        BODY_TEMPERATURE_LBL: "今日の体温",
        SIGNATURE_LBL: "本人署名",
        NEW_REGISTRATION_BTN: "新規登録",
        NEW_ENTRY_TRAINING_TITLE: "新規入場教育",
        NEW_ENTRY_REGISTER: "新規入場登録",
        ADDITIONAL_REGISTER_MESSAGE: "新規入場の追加登録がまだ完了していません。新規入場用NFCタグにスマホをタッチしてください。",
        LOGIN_TITLE: "入退場管理システム",
        LOGIN_SUBTITLE: "続行するには電話番号を入力してください",
        LOGIN_LABEL: "電話番号",
        LOGIN_DISCLAIMER: "あなたの電話番号はシステム識別のみに使用され、収集または共有されることはありません",
        LOGIN_BUTTON: "確認",
        ENTRY_SUCC_MSG: "今日も安全作業で！",
        EXIT_SUCC_MSG1: "今日も安全作業",
        EXIT_SUCC_MSG2: "ありがとうございました！",
        USERNOTEXIST: "新規ユーザー登録",
        USERNOTEXIST_SUBTITLE1: "この電話番号はシステムに登録されていません。",
        USERNOTEXIST_SUBTITLE2: "新規ユーザーとして登録するか、別の電話番号を入力してください。",
        USERNOTEXIST_BUTTON1: "新規登録顔写真",
        USERNOTEXIST_BUTTON2: "電話番号再入力",
        PARTNER_NAME_LBL: "協力業者名"
    }
}